import "./Link.scss";
import { define } from "../../../Lib/registry";
import type { Component } from "../../../Lib/types";

export type LinkVariant =
  | "default"
  | "navigation"
  | "nav"
  | "bold"
  | "underlined";

export interface LinkClickDetail {
  variant: LinkVariant;
  el: HTMLElement;
}

export class Link implements Component {
  readonly el: HTMLElement;
  readonly variant: LinkVariant;

  constructor(el: HTMLElement) {
    this.el = el;
    this.variant = (el.dataset.variant as LinkVariant) ?? "default";
    this.init();
  }

  private init(): void {
    this.el.addEventListener("click", this.handleClick);
  }

  private handleClick = (): void => {
    this.el.dispatchEvent(
      new CustomEvent<LinkClickDetail>("link:click", {
        detail: { variant: this.variant, el: this.el },
        bubbles: true,
      })
    );
  };

  destroy(): void {
    this.el.removeEventListener("click", this.handleClick);
  }
}

define("link", (el) => new Link(el));
